var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "table-wrapper" }, [
      _c("table", [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.displayedItems, function(user, index) {
            return _c("tr", { key: index }, [
              _c("td", [
                _c("span", [
                  _vm._v(_vm._s(_vm._f("formatDate")(user.createdDate)))
                ])
              ]),
              _vm._v(" "),
              _c("td", [
                user.transactionType === "Credit"
                  ? _c("span", [_vm._v("$" + _vm._s(user.amount.toFixed(2)))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                user.transactionType === "Adjustment"
                  ? _c("span", [_vm._v("-$" + _vm._s(user.amount.toFixed(2)))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                user.transactionType === "Discount Code"
                  ? _c("span", [_vm._v("-$" + _vm._s(user.amount.toFixed(2)))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                user.transactionType === "Order"
                  ? _c("span", [_vm._v("-$" + _vm._s(user.amount.toFixed(2)))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                user.transactionType === "Refund"
                  ? _c("span", [_vm._v("$" + _vm._s(user.amount.toFixed(2)))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [_c("span", [_vm._v(_vm._s(user.reference))])])
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.user && _vm.user.length > 0
      ? _c("div", { staticClass: "col-sm-12 col-md-12" }, [
          _c(
            "button",
            {
              staticClass: "pagination-button",
              attrs: { disabled: _vm.currentPage === 1 },
              on: { click: _vm.prevPage }
            },
            [_vm._v("Previous")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "current-page" }, [
            _vm._v(
              "Page " +
                _vm._s(_vm.currentPage) +
                " of " +
                _vm._s(_vm.totalPages)
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "pagination-button",
              attrs: { disabled: _vm.currentPage === _vm.totalPages },
              on: { click: _vm.nextPage }
            },
            [_vm._v("Next")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Credit")]),
        _vm._v(" "),
        _c("th", [_vm._v("Adjustment")]),
        _vm._v(" "),
        _c("th", [_vm._v("Discount Code")]),
        _vm._v(" "),
        _c("th", [_vm._v("Order")]),
        _vm._v(" "),
        _c("th", [_vm._v("Refund")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reference")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }